import {pgDurationToMs} from '../utils/dateHelper';
import {GET_ENERGY_RETENTION_PERIODS} from '../constants/energyRetentionActionTypes';
import objectAssign from 'object-assign';
// import {statusHandler} from '../utils/reducerHelper';

const initialState = {
};

// const statusHandlerFunc = statusHandler([
//   {
//     apiAction: GET_MOVEMENT_DATA,
//     statusPropName: 'getMovementStatus',
//   },
// ]);

export default function energyRetentionReducer(originalState = initialState, action) {
  // const state = statusHandlerFunc(originalState, action);
  const state = originalState;
  switch (action.type) {
    case GET_ENERGY_RETENTION_PERIODS.SUCCESS:{
      const {configId} = action.props;
      const {energyAggrRules, energyCaptureStartDate, simulationStartDate} = action.response;
      const newState = objectAssign({}, state);
      let minDate = new Date(energyCaptureStartDate);
      if (energyAggrRules.length > 0) {
        const lastPeriod = energyAggrRules[energyAggrRules.length - 1];
        if (lastPeriod.user_access === false) {
          const minDateBasedOnRetention = new Date(new Date().valueOf() - pgDurationToMs(lastPeriod.older_than));
          if (minDateBasedOnRetention > minDate) {
            minDate = minDateBasedOnRetention;
          }
        }
      }
      const obj = {periods: energyAggrRules, minDate,
        simulationStartDate: new Date(simulationStartDate),
        energyCaptureStarted: energyCaptureStartDate !== undefined,
      };

      newState[configId] = obj;
      return newState;
    }

    default:
      return state;
  }
}
